import React, { useState, useEffect } from 'react';
import Auth from '../services/Auth';
import Api from '../services/Api';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Notifications from "../services/Notifications";
import { ToastContainer } from 'react-toastify';
import Loading from './Loading';
import { useWelcomeConfig, withWelcomeConfig } from '../hooks/WelcomeConfigContext';

const Welcome = ({ currentUser }) => {
    const WelcomeConfig = useWelcomeConfig();
    const localized = WelcomeConfig.labels;
    const [storefronts, setStorefronts] = useState([]);
    const [customerNumber, setCustomerNumber] = useState("");
    const [comments, setComments] = useState("");
    const [email] = useState(currentUser.email);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [selectedStorefront, setSelectedStorefront] = useState({});
    const [loading, setLoading] = useState(false);
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

    useEffect(() => {
        fetchStorefronts();
    }, []);

    const fetchStorefronts = async () => {
        try {
            const signupData = await Api.fetch("/api/user/IsSignedUpUser");
            setIsSubmitted(signupData);            
            const response = await Api.fetch(`/api/Administrative/storefronts`);
            loadStorefronts(response);
        } catch (error) {
            console.error("Error fetching storefronts:", error);
        }
    };
    const loadStorefronts = (response) => {
        if (response) {
            const filteredStorefronts = response.filter(s => s.number !== '00000' && s.number !== '05000')
                .map(s => ({ number: s.number, name: s.displayName }))
                .sort((a, b) => a.name.localeCompare(b.name));
            setStorefronts(filteredStorefronts);
            setSelectedStorefront(filteredStorefronts.length > 0 ? filteredStorefronts[0] : {});
        }
    };
    const handleLanguageChange = (e) => {
        WelcomeConfig.updateLocale(e.target.value);
    };
    const setStoreFront = (e) => {
        const index = e.target.options.selectedIndex;
        const storeFront = e.target.options[index].text;
        setSelectedStorefront({ name: storeFront, number: e.target.value });
        setIsSubmitDisabled(index === 0);
    };

    const sendEmail = async () => {
        const userInfoData = {
            FirstName: currentUser.firstName,
            LastName: currentUser.lastName,
            Company: currentUser.company,
            StoreFront: selectedStorefront.name,
            StorefrontNumber: selectedStorefront.number,
            Email: email,
            CustomerNumber: customerNumber,
            AdditionalComments: comments
        };
        try {
            const response = await Api.fetch("api/user/SendSignedUpEmail", { body: JSON.stringify(userInfoData), method: 'POST' });
            return response;
        } catch (error) {
            console.error("Error sending email:", error);
        }
    };

    const submit = async (e) => {
        setLoading(true);
        try {
            const response = await sendEmail();
            const isSuccess = await response.json();
            setLoading(false);
            if (!isSuccess) {
                Notifications.error(localized.FailedToSendMessage);
            } else {
                setIsSubmitted(true);
            }
        } catch (error) {
            setLoading(false);
            Notifications.error(localized.FailedToSendMessage);
        }
    };
    const logout = () => {
        Auth.signOut();
    }
    const languageMapping = {
        "English": "en_US",
        "Spanish": "es_MX",
        "Spanish (Argentina)": "es_AR",
        "Spanish (Chile/Peru)": "es_CL",
        "Italian": "it_IT",
        "French": "fr_FR",
        "Portuguese": "pt_BR"
    };

    return (
        <React.Fragment>
            <ToastContainer />
            <div className="fele-business-select" style={{ marginRight: "5rem", fontSize: "2rem!important", padding: '1rem', backgroundColor: '#f9f9f9', borderRadius: '8px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
                <div className="item" style={{ flex: '0 0 auto' }}>
                    <div className="button-wrapper">
                        <button className="item log-out" onClick={logout} style={{ padding: '0.5rem 1rem', borderRadius: '4px', backgroundColor: '#007bff', color: '#fff', border: 'none', fontWeight: 'bold' }}>
                            {localized.LogOut}</button>
                    </div>
                </div>
                <hr></hr>

                <div className="item" style={{ flex: '1', marginRight: '2rem' }}>
                    <div className="label">{localized.SelectLanguage}</div>
                    <div className="select-wrapper">
                        <select value={WelcomeConfig.locale} onChange={handleLanguageChange} >
                            {Object.entries(languageMapping).map(([name, code]) => (
                                <option key={code} value={code}>{name}</option>
                            ))}
                        </select>
                    </div>
                </div>

            </div>
            {isSubmitted ? (
                <div className="fele-welcome">
                    <div className="fele-content heading2">{localized.SuccessMessage}</div>
                    <div className="fele-content heading3">{localized.CustomerMessage}</div>
                    <div className="button-wrapper large">
                        <a style={{ textDecoration: "none" }} href={localized.LearningFEDirectURL}>
                            <button className="button submit-order">{localized.FEDirectLink}</button>
                        </a>
                    </div>
                </div>
            ) : (
                <div className="fele-welcome">
                    <div className="fele-content heading2">{localized.ThankYouSigningUpMessage}</div>
                    <div className="fele-content heading3">{localized.SelectStoreFrontQuestion}</div>
                    <div className="fele-content heading4">{localized.WhereDoYouDoBusinessQuestion}</div>
                    <div className="fele-business-select">
                        <div className="select-wrapper">
                            <select onChange={setStoreFront} style={isSubmitDisabled ? { border: '2px solid #0d6efd' } : {}} required>
                                <option value="" style={{ color: 'gray' }}>{localized.SelectStorefront}</option>
                                {Object.keys(storefronts).map((o) => (
                                    <option key={o} value={storefronts[o].number}>{storefronts[o].name}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="welcome-input-text">
                        <div className="heading3"></div>
                        <div className="fele-content">
                            <div className="input-wrapper">
                                <input data-cy="welcome-customer-number" type="text" placeholder={localized.CustomerNumber} value={customerNumber}
                                    onChange={e => setCustomerNumber(e.target.value)} />
                            </div>
                        </div>
                    </div>
                    <div className="comments-input-text">
                        <div className="heading3">{localized.AdditionalComments}</div>
                        <div className="fele-content">
                            <div className="input-wrapper">
                                <textarea value={comments} onChange={e => setComments(e.target.value)} />
                            </div>
                        </div>
                    </div>
                    {!loading ? (
                        <div className="button-wrapper large">
                            <button className="button submit-order" onClick={submit} disabled={isSubmitDisabled} style={isSubmitDisabled ? { color: 'gray' } : {}}>{localized.Submit}</button>
                        </div>
                    ) : (
                        <Loading type="brand" />
                    )}
                </div>
            )}
        </React.Fragment>
    );
};

Welcome.propTypes = {
    currentUser: PropTypes.object
};

const mapStateToProps = (state) => ({
    currentUser: state.user.currentUser
});
export default connect(mapStateToProps, null)(withWelcomeConfig(Welcome));